import { useGlobalFilter } from "hooks/useGlobalFilter";
import { useAuthCustomerIdSelector } from "modules/auth";
import { CustomersApi } from "modules/customers";

export function useProxy() {
  const {
    isGlobalFiltering,
    globallyFilteredCustomer,
    isLoading: globalFilteredCustomerLoading,
    isError: globalFilteredCustomerError,
  } = useGlobalFilter();
  const authCustomerId = useAuthCustomerIdSelector() ?? "";

  const {
    data: customer,
    isLoading: customerLoading,
    isError: customerError,
  } = CustomersApi.useGetCustomerQuery(
    { id: authCustomerId },
    { skip: !authCustomerId || isGlobalFiltering }
  );

  return {
    error: customerError || globalFilteredCustomerError,
    loading: customerLoading || globalFilteredCustomerLoading,
    customer: customer ?? globallyFilteredCustomer,
  };
}
